import {
  EDP_MAX_FIELD_DESCRIPTION_LENGTH,
  FieldResponse,
} from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { isRequired, makeIsNoLongerThan } from '../../../utils/validators';
import { CheckboxField } from '../../fields/CheckboxField';
import { TextField } from '../../fields/TextField';
import { Tooltip } from '../../Tooltip';
import { DataTypeBase } from './DataTypeBase';

const FieldLabel = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 45rem;
  margin: 0 0 1rem;
`;

const FieldLabelInput = styled(TextField)`
  flex-direction: column;
  width: 35rem;
  margin-bottom: 0;
` as typeof TextField;

const FieldDescription = styled(TextField)`
  width: 35rem;
`;

interface GenericDataTypeProps {
  children?: React.ReactNode;
  isRequiredHelpText?: string;
  collectionLabel?: string;
  allowVersioning?: boolean;
}

export function GenericDataType({
  children,
  isRequiredHelpText,
  collectionLabel,
  allowVersioning = false,
}: GenericDataTypeProps) {
  return (
    <DataTypeBase>
      <FieldLabel>
        <FieldLabelInput<FieldResponse['name']>
          label="Field Label"
          name="name"
          validate={isRequired}
          required
          dontSaveSpaceForErrorText
        />
        <CheckboxField<FieldResponse['isRequired']>
          label={
            <>
              Required field
              {isRequiredHelpText && <Tooltip title={isRequiredHelpText} />}
            </>
          }
          name="isRequired"
        />
      </FieldLabel>
      <FieldDescription
        label="Description"
        helperText={`This information will appear on the manual data submission form for this ${collectionLabel}.`}
        name="description"
        multiline
        rows={4}
        validate={makeIsNoLongerThan(EDP_MAX_FIELD_DESCRIPTION_LENGTH)}
      />
      {!!children && children}
      {allowVersioning && (
        <CheckboxField<FieldResponse['isVersioned']>
          label="Enable Effective Dates"
          name="isVersioned"
          helperText="Effective dates allow you to specify a start and end date for variable properties."
        />
      )}
    </DataTypeBase>
  );
}
